import React from 'react';
import { StyleSheet, View } from 'react-native';

export const TopMenu = props => {
    return <View style={StyleSheet.flatten(Styles.container, props.style)}>{props.children}</View>;
};

const Styles = StyleSheet.create({
    container: {
        backgroundColor: 'transparent',
        justifyContent: 'center',
        width: '100%'
    }
});
